import { api } from ":mods";
import { ENDPOINTS } from "../../const";

export async function deleteCollectionDetails(id: string | number, collection_id: string | number) {
  const collection = `?collection=${collection_id}`;
  return api.delAuth(ENDPOINTS.material_details_with_material_id_student + id + "/" + collection);
}
